import { css } from '@emotion/react';
import { SHADOW_MD } from '../../sharedComponents/v1/Tokens/BoxShadow';

export const styContainer = css({
  padding: 30,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid var(--deprecated-neutral-300)',
  boxShadow: SHADOW_MD,
  background: 'var(--deprecated-neutral-25)',
  borderRadius: 16,
  gap: 24,
  textAlign: 'center',
  width: 'fit-content',
  height: 'fit-content',
});

export const styIconContainer = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 72,
  height: 72,
  minWidth: 72,
  minHeight: 72,
  borderRadius: 10,
  border: '1px solid var(--deprecated-neutral-300)',
  padding: 16,
});

export const styButtonIcon = css({
  '& svg': {
    width: 24,
    height: 24,
  },
  width: 24,
  height: 24,
});
